import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import Logo from '../../containers/Logo';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import { getUrl } from '../../utils';
import { usePage } from '../../contexts/pageContext';
import constantes from '../../resources/constantes.json';
import { responsive } from '../../resources/constantes.json';
import { useEleccion } from '../../contexts/eleccionContext';
import { fmt } from '../../utils';
import FlechaDerecha from '../../assets/img/FlechaDerecha.jsx';
import LinkWithTop from '../../components/Links/LinkWithTop';

function ConditionalContainer({
  children,
  esHistorico,
  amb,
  eleccion,
  nomenclator,
}) {
  return (
    <>
      {esHistorico ? (
        <HLink>{children}</HLink>
      ) : (
        <SLink
          to={
            esHistorico
              ? '#'
              : getUrl({
                  id: amb.i,
                  eleccion,
                  nomenclator,
                  page: constantes.nombreEleccion[eleccion],
                })
          }
        >
          {children}
        </SLink>
      )}
    </>
  );
}

const FilaTablaTerritorios = props => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const elecOptions = useEleccion();
  const { urlInfo } = pageState;
  const { idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const ColorPartido =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].color;
  const LogoPartido =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].codpar;
  const NombrePar =
    nomenclator.partidos[Number(props.territorio.codpar) - 1].nombre;
  const eleccion = elecOptions.idEleccion;

  if (!nomenclator) return null;

  const amb = nomenclator.ambitos[eleccion].find(
    y => y.c === props.territorio.amb
  );

  if (!amb) return null;
  return (
    <div style={{ cursor: esHistorico ? 'default' : 'pointer' }}>
      <ConditionalContainer
        esHistorico={esHistorico}
        amb={amb}
        eleccion={eleccion}
        nomenclator={nomenclator}
      >
        <ContainerFila>
          <FirstColumn>
            <Territorio>
              {!esHistorico ? (
                <>{props.territorio.nombre}</>
              ) : (
                <p className="dataTitle" css="color: #222;">
                  {props.territorio.nombre}
                </p>
              )}
            </Territorio>
            <StyledLogo
              height={'60px'}
              codpar={props.territorio.hayEmpate === '1' ? '-1' : LogoPartido}
              hideLogo={
                props.territorio.hayEmpate === '1' || !props.hayGanadores
              }
              stylesContenedorLogo={{ justifyContent: 'flex-start' }}
            />
          </FirstColumn>
          <SecondColumn>
            <>
              {props.hayGanadores && (
                <DatosPartido>
                  <Color
                    color={
                      props.territorio.hayEmpate === '1'
                        ? '#F5AD00'
                        : ColorPartido
                    }
                  />
                  <NombrePartido>
                    {props.territorio.hayEmpate === '1'
                      ? t('empate')
                      : NombrePar}
                  </NombrePartido>
                </DatosPartido>
              )}
              <Mesas>
                <MesasInformadas>
                  <p className="dataTitle">Mesas informadas</p>
                  <p className="dataPorc">{props.territorio.pmesesc}</p>
                  <p className="dataABS">{fmt(props.territorio.mesesc)}</p>
                </MesasInformadas>
                <Votantes>
                  <p className="dataTitle">Votos</p>
                  <p className="dataPorc">{props.territorio.pvot}</p>
                  <p className="dataABS">{fmt(props.territorio.vot)}</p>
                </Votantes>
              </Mesas>
            </>
          </SecondColumn>
          <ThirdColumn>
            <div
              style={{
                borderRadius: '100%',
                backgroundColor: '#215CCC',
                color: 'white',
                alignSelf: 'center',
                justifySelf: 'center',
                textAlign: 'center',
                height: '5rem',
                width: '5rem',
                marginTop: 'auto',
                marginBottom: 'auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <FlechaDerecha style={{ margin: 'auto', height: '20px' }} />
            </div>
          </ThirdColumn>
        </ContainerFila>
        <ContainerFilaMobile>
          <FirstRow>
            <div
              style={{
                fontWeight: '700',
                fontSize: '1.6rem',
                alignSelf: 'center',
              }}
            >
              {!esHistorico ? (
                <>{props.territorio.nombre}</>
              ) : (
                <p className="dataTitle" css="color: #222;">
                  {props.territorio.nombre}
                </p>
              )}
            </div>
            <div
              style={{
                height: '100%',
                marginLeft: 'auto',
                marginRight: '20px',
              }}
            >
              <StyledLogoMobile
                height={'35px'}
                codpar={props.territorio.hayEmpate === '1' ? '-1' : LogoPartido}
                hideLogo={
                  props.territorio.hayEmpate === '1' || !props.hayGanadores
                }
              />
            </div>
            <div
              style={{
                borderRadius: '100%',
                backgroundColor: '#215CCC',
                color: 'white',
                alignSelf: 'center',
                justifySelf: 'center',
                textAlign: 'center',
                height: '30px',
                width: '30px',
                marginTop: 'auto',
                marginBottom: 'auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <FlechaDerecha style={{ margin: 'auto', height: '20px' }} />
            </div>
          </FirstRow>
          <DataRow>
            {props.hayGanadores && (
              <DatosPartido style={{ marginBottom: '12px' }}>
                <Color
                  style={{ marginLeft: '0px', marginRight: '8px' }}
                  color={
                    props.territorio.hayEmpate === '1'
                      ? '#F5AD00'
                      : ColorPartido
                  }
                />
                <NombrePartido>
                  {props.territorio.hayEmpate === '1' ? t('empate') : NombrePar}
                </NombrePartido>
              </DatosPartido>
            )}
          </DataRow>
          <DataRow>
            <div style={{ width: '50%' }}>
              <p className="title">Votos</p>
            </div>
            <div style={{ width: '25%' }}>
              <p className="porc">{props.territorio.pvot}</p>
            </div>
            <div style={{ width: '25%' }}>
              <p className="num">{fmt(props.territorio.vot)}</p>
            </div>
          </DataRow>
          <DataRow>
            <div style={{ width: '50%' }}>
              <p className="title">MESAS INFORMADAS</p>
            </div>
            <div style={{ width: '25%' }}>
              <p className="porc">{props.territorio.pmesesc}</p>
            </div>
            <div style={{ width: '25%' }}>
              <p className="num">{fmt(props.territorio.mesesc)}</p>
            </div>
          </DataRow>
        </ContainerFilaMobile>
      </ConditionalContainer>
    </div>
  );
};

const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  background: grey;
`;

const ContainerFila = styled.div`
  display: flex;
  flex-direction: row;
  padding: 16px 4px;
  width: 99%;
  @media screen and (max-width: ${responsive.mobile}px) {
    display: none;
  }
  @media (min-width: ${responsive.tablet + 1}px) {
    width: 95%;
  }
`;

const ContainerSegundaFila = styled.div`
  display: flex;
  width: 98%;
  margin: auto;
  .dataABS {
    font-weight: 100;
    @media screen and (max-width: ${responsive.mobile}px) {
      text-align: right;
    }
  }
  .dataPorc {
    font-weight: 600;
    @media screen and (max-width: ${responsive.mobile}px) {
      text-align: right;
    }
  }
  .dataTitle {
    font-weight: 700;
  }
  .dataTitle.pmv {
    @media screen and (max-width: ${responsive.mobile}px) {
      width: 25%;
    }
  }
  @media screen and (max-width: ${responsive.mobile}px) {
    flex-direction: column;
  }
`;

const Territorio = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  font-weight: 700;
  font-size: 1.8rem;
`;

const NombrePartido = styled.div`
  width: 100%;
  @media screen and (max-width: 500px) {
    font-weight: 400;
    font-size: 12px;
  }
`;

const PartidoMasVotado = styled.div`
  width: 60%;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 100%;
    display: flex;
    align-items: center;
  }
`;

const MesasInformadas = styled.div`
  width: 65%;
  justify-content: center;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Votantes = styled.div`
  width: 25%;
  justify-content: center;
  @media screen and (max-width: ${responsive.mobile}px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 500px) {
    width: 100%;
  }
`;

const Color = styled(({ color, ...rest }) => <div {...rest} />)`
  width: 10px;
  min-width: 10px;
  height: 10px;
  margin: 0rem 0.5rem 0rem 1.5rem;
  background: ${({ color }) => (color ? color : '#fff')};
  border-radius: 100%;
  display: block;
`;

const DatosPartido = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
`;

const SLink = styled(LinkWithTop)`
  color: #164192;
  overflow: hidden;
  background: #f5f8fd;
  border-radius: 0.8rem;
  margin: 1.6rem;
  margin-left: 0;
  border: 2px solid transparent;
  &:focus {
    border-color: grey;
    & * {
      text-decoration: none;
    }
  }
  &:hover {
    text-decoration: none;
    cursor: inherit;
  }
  display: flex;
  justify-content: center;
  @media (max-width: ${responsive.tablet}px) {
    margin-left: 1.6rem;
  }
  @media (max-width: ${responsive.mobile}px) {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
  @media (min-width: ${responsive.tablet + 1}px) {
    transition-duration: 250ms;
    &:hover {
      transform: scale(1.01);
      text-decoration: none;
    }
  }
`;

const HLink = styled.span`
  color: #164192;
  overflow: hidden;
  background: #f5f8fd;
  border-radius: 0.8rem;
  margin: 1.6rem;
  margin-left: 0;
  border: 2px solid transparent;
  &:focus {
    border-color: grey;
    & * {
      text-decoration: none;
    }
  }
  &:hover {
    text-decoration: none;
    cursor: inherit;
  }
  display: flex;
  justify-content: center;
  @media (max-width: ${responsive.tablet}px) {
    margin-left: 1.6rem;
  }
  @media (max-width: ${responsive.mobile}px) {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
  }
  @media (min-width: ${responsive.tablet + 1}px) {
    transition-duration: 250ms;
    &:hover {
      transform: scale(1.01);
      text-decoration: none;
    }
  }
`;

const FirstColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 25%;
  font-weight: 700;
  text-align: left;
  row-gap: 8px;
  padding-left: 50px;
  @media (max-width: ${responsive.desktop}px) {
    padding-left: 30px;
  }
`;
const SecondColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  padding-left: auto;
  padding-right: auto;
  justify-content: space-between;
`;
const ThirdColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 20%;
`;

const Mesas = styled.div`
  display: flex;
  flex-direction: row;
  p {
    font-weight: 400;
    padding-left: 16px;
    margin-bottom: -4px;
    font-size: 1.4rem;
  }
  .dataPorc {
    font-weight: 700;
    font-size: 1.8rem;
  }
`;

const ContainerFilaMobile = styled.div`
  display: none;
  @media screen and (max-width: ${responsive.mobile}px) {
    display: flex;
    flex-direction: column;
    width: 97%;
    margin-bottom: 5px;
    background: #f5f8fd;
    width: 99%;
    border-radius: 30px;
    padding: 20px;
  }
`;

const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: 12px;
`;

const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .title {
    font-weight: 700;
  }
  .porc {
    font-weight: 700;
    text-align: end;
  }
  .num {
    text-align: end;
  }
`;

const StyledLogoMobile = styled(Logo)`
  background: grey;
  height: 35px;
`;

export default FilaTablaTerritorios;
